import Image from 'next/image';
import { FC, useEffect, useState } from 'react';
import { Carousel } from 'react-bootstrap';
import styles from './ImageSlider.module.scss';
import { fetchRemoteConfig } from '@/hotdesk-ui/common-classes/firebase.service';
import { RemoteConfigKeys } from '@/hotdesk-ui/enum/remote-keys';
import SafeImage from '@/hotdesk-ui/components/shared/SafeImage';
const DEFAULT_IMAGE = 'https://hotdesk-assets.s3.eu-west-1.amazonaws.com/landing_pages/workspace_directory/defaultImage.webp';
export interface ImageSlider {
  images: {
    [key: string]: any;
  };
  title: string;
  url: string;
  width?: string;
  height?: string;
  moveToRoute?: () => void;
  subscriptionName?: string | null;
  listingsInPopup?: boolean;
  mapCard?: boolean;
  target?: string;
  rel?: string;
}
const prevIcon = () => {
  return <Image loading="lazy" className={styles.prev} src="/assets/icons/left-cursor.svg" alt="workspace-image" width={28} height={28} data-sentry-element="Image" data-sentry-component="prevIcon" data-sentry-source-file="ImageSlider.tsx" />;
};
const nextIcon = () => {
  return <Image loading="lazy" className={styles.next} src="/assets/icons/right-cursor.svg" alt="workspace-image" width={28} height={28} data-sentry-element="Image" data-sentry-component="nextIcon" data-sentry-source-file="ImageSlider.tsx" />;
};
const ImageSlider: FC<ImageSlider> = ({
  images = {},
  title = '',
  moveToRoute,
  url,
  width = '100%',
  height = '275px',
  subscriptionName,
  listingsInPopup = false,
  mapCard = false,
  target = '_self',
  rel = ''
}) => {
  height = listingsInPopup ? '152px' : height;
  const imageRadius = mapCard ? '16px 16px 0 0' : '8px';
  const [imgSizee, setImgsize] = useState('/sm');
  const imagesArray = Object.values(images);
  useEffect(() => {
    fetchRemoteConfig(RemoteConfigKeys.WEB_DIRECTORY_IMAGE_SIZE_EXPLORE, 'string').then(imgSize => {
      setImgsize(imgSize as string);
    });
  }, []);
  return <>
            <div className={`position-relative${mapCard ? ` ${styles.mapCard}` : ''}`} dir="ltr">
                {subscriptionName !== null && !!subscriptionName && <div className={`p-2 mt-3 mx-3 d-flex ${styles.caption}`}>
                        <Image src="/assets/icons/success.svg" alt="subscription-icon" width={20} height={20} />
                        <p className="m-0 mx-1">{subscriptionName}</p>
                    </div>}
                {imagesArray.length > 1 ? <Carousel interval={null} prevIcon={prevIcon()} nextIcon={nextIcon()} onClick={e => e.stopPropagation()} onTouchStart={e => e.stopPropagation()}>
                        {imagesArray.map((imagePath, index) => <Carousel.Item key={`image-${index}`}>
                                <a href={url} onClick={moveToRoute} target={target} rel={rel}>
                                    <div style={{
              width: width,
              height: height,
              position: 'relative',
              borderRadius: imageRadius,
              background: '#e0e0e0'
            }}>
                                        <SafeImage onClick={moveToRoute} src={imagePath + imgSizee} alt={title} style={{
                borderRadius: imageRadius,
                objectFit: 'cover'
              }} className="mb-1" fill={true} sizes="100%" loading="lazy" blurDataURL={DEFAULT_IMAGE} />
                                    </div>
                                </a>
                            </Carousel.Item>)}
                    </Carousel> : imagesArray.length == 1 ? <a href={url} onClick={moveToRoute} target={target} rel={rel}>
                        <div style={{
          width: width,
          height: height,
          position: 'relative',
          borderRadius: imageRadius,
          background: '#e0e0e0'
        }}>
                            <SafeImage src={imagesArray[0] + imgSizee} onClick={moveToRoute} alt={title} style={{
            borderRadius: imageRadius,
            objectFit: 'cover'
          }} className="mb-1" fill={true} sizes="100%" loading="lazy" blurDataURL={DEFAULT_IMAGE} />
                        </div>
                    </a> : <a href={url} onClick={moveToRoute} target={target} rel={rel}>
                        <div style={{
          width: '100%',
          height: '275px',
          position: 'relative',
          borderRadius: imageRadius,
          background: '#e0e0e0'
        }}>
                            <Image src={DEFAULT_IMAGE} onClick={moveToRoute} alt={title} style={{
            borderRadius: imageRadius,
            objectFit: 'cover'
          }} className="mb-1" fill={true} sizes="100%" loading="lazy" blurDataURL={DEFAULT_IMAGE} />
                        </div>
                    </a>}
            </div>
        </>;
};
export default ImageSlider;